export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[{"rel":"preload","as":"style","href":"/css/local-google-fonts.css","onload":"this.onload=null;this.rel='stylesheet'"}],"style":[{"innerHTML":"/* ============================================================\n   Utopia fluid type scale (360px → 1240px)\n   @link https://utopia.fyi/type/calculator?c=360,16,1.2,1240,20,1.25,5,2\n   ============================================================ */\n:root {\n    --fluid--2: clamp(0.6944rem, 0.6685rem + 0.1148vw, 0.7813rem);\n    --fluid--1: clamp(0.8333rem, 0.7867rem + 0.2068vw, 0.9766rem);\n    --fluid-0:  clamp(1rem, 0.9273rem + 0.3227vw, 1.2206rem);\n    --fluid-1:  clamp(1.2rem, 1.0943rem + 0.4695vw, 1.5256rem);\n    --fluid-2:  clamp(1.44rem, 1.2916rem + 0.6583vw, 1.9069rem);\n    --fluid-3:  clamp(1.728rem, 1.5237rem + 0.9065vw, 2.3834rem);\n    --fluid-4:  clamp(2.0736rem, 1.7954rem + 1.234vw, 2.9791rem);\n    --fluid-5:  clamp(2.4883rem, 2.1121rem + 1.6682vw, 3.7239rem);\n\n    --cms-description-size: var(--fluid--1);\n    --cms-info-size:        var(--fluid--1);\n    --cms-body-size:        var(--fluid-0);\n    --cms-button-size:      var(--fluid-0);\n    --cms-nav-size:         var(--fluid-0);\n    --cms-card-title-size:  var(--fluid-1);\n    --cms-subtitle-size:    var(--fluid-2);\n    --cms-heading-size:     var(--fluid-3);\n}\n\n/* Arimo font configuration (fallback to sans-serif if not found) */\n@font-face {\n    font-family: 'Arimo';\n    src: local('Arimo'), local('Arimo Regular'), local('Arimo-Regular'), sans-serif;\n    font-style: normal;\n    font-weight: 100 700;\n    font-display: swap;\n}\n\n/* 恢复特定标签的浏览器默认样式 */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    font-size: revert;\n    font-weight: revert;\n    margin: revert;\n}\n\np {\n    margin: revert;\n}\n\n.font-arimo {\n    font-family: 'Arimo', sans-serif !important;\n}\n\n/* .ql-editor p strong {\n    color: #000 !important;\n} */"}],"script":[],"noscript":[{"innerHTML":"<link rel=\"stylesheet\" href=\"/css/local-google-fonts.css\"><link rel=\"stylesheet\" href=\"/css/bootstrap.min.css\">"}]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = false

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true